import { Box } from '@apia/theme';
import { TRequireOnlyOne } from '../../types';
import { getFileExtension } from '../../utils/files';

export type TFileIcon = {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
} & TRequireOnlyOne<{ fileName: string; type: string }>;

const FileIcon = ({ className, fileName, size, type }: TFileIcon) => {
  const actualType = type ?? getFileExtension(fileName ?? '');

  return (
    <Box
      className={`file-icon ${
        size !== 'md' && size !== undefined ? `file-icon-${size}` : ''
      } ${className ?? ''}`}
      data-type={actualType}
    />
  );
};

export default FileIcon;
